
import { mixins, Options } from 'vue-class-component';
import { EthereumProvider } from '@manifoldxyz/manifold-sdk';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import { Redemption, RedemptionResult } from '../api/models/redemption';
import LazyImage from './LazyImage.vue';
import MToken from './MToken.vue';

@Options({
  components: {
    LazyImage,
    MToken
  }
})
export default class MDiscount extends mixins(CampaignWidgetMixin) {
  isSubmittingRedemption = false;

  // Vue lifecycle hooks
  async created() {
    await this.getDescription();
  }

  // Vue lifecycle hooks ends
  // component methods
  get buttonText() {
    return this.innerClaimText ? this.innerClaimText : 'Checkout';
  }

  get redemptionToToken() {
    const currentRedemption = this.state.activeRedemption!;
    return (currentRedemption as any)[0]?.discountCode;
  }

  goBack() {
    this.clearActiveTokenAndRedemption();
  }

  async getDescription() {
    if (!EthereumProvider.selectedAddress()) {
      return;
    }

    const oauthToken = await this.getOAuth();

    // Request to get the discount code details
    // @ts-ignore
    this.state.description = await this.state.RedeemAPIClient.getCampaignShopifyDiscountDescription(
      oauthToken!,
      parseInt(this.mmid!)
    );
  }

  async submitSelection(_submitEvent: any) {
    this.isSubmittingRedemption = true;
    try {
      const { network, contractAddress, tokenId } = this.state.activeEligibleToken!;
      const redemption = new Redemption(network, contractAddress, tokenId);
      const oauthToken = await this.getOAuth();
      // Request to create the redemption
      const res = RedemptionResult.fromJson(
        await this.state.RedeemAPIClient.submitRedemptionDiscount(
          oauthToken!,
          parseInt(this.mmid!),
          redemption
        )
      );
      this.setRedemptionDetails(res);

      await this.updateState(true);
    } catch {
      alert('Error encountered during submission. Please try again.');
    } finally {
      this.isSubmittingRedemption = false;
    }
  }
}
